require('jquery-ui/ui/effects/effect-shake');

$(function() {
  if($('.ecommerce .collections').length) {
    $('.js-favorite-icon').effect('shake', {times: 3, distance: 2}, 600);
  }
});
